
<template>
  <div class="col-12">
    <SearchCard
      :title="$lang.ticketLang.my_tickets"
      :url="url"
      ref="allTicketSearch"
      :filterCatch="true"
      :html="false"
      :showQuickFilter="true"
      @updatePermissions="updatePermissions"
    >
      <template slot="buttons">
        <span
          v-if="isAdmin(permissions, ['admin'])"
          @click="addTicket"
          v-b-tooltip.hover
          :title="$lang.ticketLang.add_ticket"
          class="ml-2"
        >
          <mdicon name="plus" size="24" class="cursor_pointer" />
        </span>
      </template>
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="
            p-3
            card_border_bottom
            color_second
            font_16 font_weight_bold
            bg-white
          "
          v-text="item.ticket_subject"
        />
        <b-col
          cols="12"
          md="12"
          class="p-3 d-flex align-items-start justify-content-between bg-white"
        >
          <div class="color_black mb-2">
            <strong v-text="'شماره درخواست: '" />
            <span v-text="pathOr('', ['ticket_code'], item)" />
          </div>
          <span
            v-text="pathOr('', ['ticket_status_id', 'caption'], item)"
            :class="`badge_style badge_style--${pathOr(
              'danger',
              ['ticket_status_id', 'color'],
              item
            )}`"
          />
        </b-col>
        <b-col cols="12" md="" class="color_second bg-white">
          <b-row>
            <b-col cols="12" md="12" class="color_black mb-2 dir_ltr">
              <strong v-text="'زمان ایجاد: '" />
              <span v-text="pathOr('', ['created_at', 'jalali'], item)" />
            </b-col>
            <b-col cols="12" md="12" class="color_black my-2">
              <strong v-text="`${$lang.ticketLang.parvandeh}: `" />

              <span
                v-text="pathOr('', ['parvandeh', 'parvandeh_number'], item)"
              />
            </b-col>
            <b-col
              cols=""
              class="color_black d-md-none d-flex align-items-center my-2"
            >
              <strong v-text="'آخرین بررسی: '" />
              <span
                class="ml-1"
                v-text="
                  $moment(
                    pathOr('', ['updated_at', 'gregorian'], item)
                  ).fromNow()
                "
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="3" class="pt-md-2 bg-white">
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="color_black text-md-center d-md-block d-none"
            >
              <strong v-text="'آخرین بررسی: '" />
              <span
                class="ml-1"
                v-text="
                  $moment(
                    pathOr('', ['updated_at', 'gregorian'], item)
                  ).fromNow()
                "
              />
            </b-col>
            <b-col cols="12" md="12" class="my-3">
              <span @click="editTicket(item)">
                <Button
                  :click="() => {}"
                  :title="buttonTitle(item)"
                  btnClass="font_20"
                />
              </span>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-if="pathOr([], ['tags'], item).length"
          cols="12"
          md="12"
          class="bg-white py-2 card_border_top"
        >
          <b-row class="mx-0">
            <b-col
              cols="auto"
              md="auto"
              class="pr-3"
              v-for="(tag, index) in pathOr([], ['tags'], item)"
              :key="index"
            >
              <div class="color_primary">
                <mdicon name="tag-outline" size="16" />
                <span
                  class="ml-1 font_12 font_weight_500"
                  v-text="tag.caption"
                />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
  </div>
</template>

<script>
import SearchCard from "@/components/global/searchCard";
import Button from "@/components/global/Button";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { renderEumOptions, isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "new-ticket-search",
  components: {
    SearchCard,
    Button,
  },
  validations: {
    ticketSubject: { required },
    ticketUnitSelected: { required },
    hasSendSms: { required },
  },
  data() {
    return {
      importExcelModal: false,
      ticketSubject: null,
      ticketUnitSelected: null,
      hasSendSms: false,
      isValidAppendData: false,
      permissions: [],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["ticket", "base"]);
    },
    appendData() {
      return {
        ticket_subject: this.ticketSubject,
        ticket_unit_id: pathOr(null, ["value"], this.ticketUnitSelected),
        send_message: this.hasSendSms ? 1 : 0,
      };
    },
    ticketUnitOptions() {
      return renderEumOptions("ticket_unit");
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    updatePermissions(data) {
      this.permissions = data;
    },
    getData() {
      this.$refs.allTicketSearch.getItems();
    },
    editTicket(item) {
      this.$router.push({
        name: "user_edit_ticket",
        params: {
          code: item.code,
        },
      });
    },
    addTicket() {
      this.$router.push({ name: "user_add_ticket" });
    },
    buttonTitle(item) {
      const defaultText = isAdmin(this.permissions)
        ? this.$lang.edit
        : this.$lang.view;
      return pathOr(null, ["ticket_status_id", "id"], item) === 4
        ? this.$lang.view
        : defaultText;
    },
  },
};
</script>
